'use strict';

import { Entity } from '../Entity';

export class IndEmployer extends Entity {
  protected id;

  protected ind;

  protected employer;

  protected department;

  protected departmentCode;

  protected location;

  protected employeeStatus;

  protected tierName;

  protected benefitPlan;

  protected employeeId;

  protected enrollmentStatus;

  protected coverageEffective;

  protected salary;

  protected hireDate;

  protected notes;

  protected benefitPlanType;

  protected costTierEffectiveDate;

  protected benefitClassDate;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.ind = data.ind;

    this.employer = data.employer;

    this.department = data.department;

    this.departmentCode = data.departmentCode;

    this.location = data.location;

    this.employeeStatus = data.employeeStatus;

    this.tierName = data.tierName;

    this.benefitPlan = data.benefitPlan;

    this.employeeId = data.employeeId;

    this.enrollmentStatus = data.enrollmentStatus;

    this.coverageEffective = data.coverageEffective;

    this.salary = data.salary;

    this.hireDate = data.hireDate;

    this.notes = data.notes;

    this.benefitPlanType = data.benefitPlanType;

    this.costTierEffectiveDate = data.costTierEffectiveDate;

    this.benefitClassDate = data.benefitClassDate;
  }

  public getId() {
    return this.id;
  }

  public getInd() {
    return this.ind;
  }

  public getEmployer() {
    return this.employer;
  }

  public getDepartment() {
    return this.department;
  }

  public getDepartmentCode() {
    return this.departmentCode;
  }

  public getLocation() {
    return this.location;
  }

  public getEmployeeStatus() {
    return this.employeeStatus;
  }

  public getTierName() {
    return this.tierName;
  }

  public getBenefitPlan() {
    return this.benefitPlan;
  }

  public getEmployeeId() {
    return this.employeeId;
  }

  public getEnrollmentStatus() {
    return this.enrollmentStatus;
  }

  public getCoverageEffective() {
    return this.coverageEffective;
  }

  public getSalary() {
    return this.salary;
  }

  public getHireDate() {
    return this.hireDate;
  }

  public getNotes() {
    return this.notes;
  }

  public getBenefitPlanType() {
    return this.benefitPlanType;
  }

  public getCostTierEffectiveDate() {
    return this.costTierEffectiveDate;
  }

  public getBenefitClassDate() {
    return this.benefitClassDate;
  }
}
